module.exports = __webpack_public_path__ + "img/47_34.ebc579bb.png";